import { css } from 'styled-components';
import { mix, shade } from 'polished';

/** Cores oficiais da marca Fuzzy Makers. */
export const brand = {
  green: '#4CAF50',
  blue: '#1E88E5',
  orange: '#FF9800',
  gray: '#9E9E9E',
  white: '#FFFEFC',
} as const;

/** Texto principal usado em toda a plataforma. */
export const ink = '#323232';

/**
 * Derivados das cores da marca. As cores puras ficam para fundos, ícones e
 * bordas; texto pequeno usa a versão escura (`text`) para passar de 4.5:1
 * sobre o branco da marca. O cinza puro (#9E9E9E) dá só 2.6:1 sobre branco:
 * serve para borda, ícone e estado desabilitado, não para texto.
 */
const tone = (color: string) => ({
  solid: color,
  text: shade(0.42, color),
  soft: mix(0.12, color, brand.white),
  border: mix(0.35, color, brand.white),
});

export const tones = {
  green: tone(brand.green),
  blue: tone(brand.blue),
  orange: tone(brand.orange),
  gray: {
    ...tone(brand.gray),
    text: shade(0.35, brand.gray),
  },
  red: tone('#E53935'),
} as const;

export type TBrandTone = keyof typeof tones;

/** Ouro, prata e bronze do pódio — fora da paleta, só para posições 1 a 3. */
export const podium = {
  1: '#C99A06',
  2: '#8A96A3',
  3: '#B4682F',
} as const;

export const surface = {
  page: '#F6F7F9',
  card: brand.white,
  line: '#E2E2E2',
} as const;

/** Breakpoints da feature de torneio (rem). */
export const breakpoints = {
  sm: '30rem',
  md: '48rem',
  lg: '80rem',
} as const;

/** As mesmas faixas para `useMediaQuery`, para o JS e o CSS concordarem. */
export const media = {
  sm: `(max-width: ${breakpoints.sm})`,
  md: `(max-width: ${breakpoints.md})`,
  lg: `(max-width: ${breakpoints.lg})`,
} as const;

/** Alvo mínimo de toque. */
export const touchTarget = '2.75rem';

/**
 * Toque sem atraso nem flash cinza, e resposta no instante em que o dedo
 * pressiona. Aplicado no container de cada tela da feature de torneio.
 */
export const touchFeedback = css`
  button,
  a,
  select {
    touch-action: manipulation;
    -webkit-tap-highlight-color: transparent;
  }

  button:not(:disabled):active {
    transform: scale(0.97);
  }

  @media (prefers-reduced-motion: reduce) {
    button:not(:disabled):active {
      transform: none;
    }
  }
`;
